import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, IconButton, Icon } from 'rsuite'
import AttachFilesFormProjectEvaluation from './AttachFilesFormProjectEvaluation'
import { useForm, Controller } from 'react-hook-form'
import {
  getDownloadProjectEvaluation,
  getAttachments,
  saveProjectEvaluationProgress,
  saveProjectEvaluationEvaluation,
  updateAttachments,
  deleteAttachments,
  changeAttachmentSeqNo,
} from '../../redux/actions/attachments'
import { startLoading, doneLoading } from '../../utils/loading'

export default function AttachFilesProjectEvaluationWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, handleGetSchema } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [section, setSection] = useState()
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isProgress, setIsProgress] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleUpdate = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsEditErr()
    try {
      console.log('update')
      const response = await updateAttachments(projectId, request)

      console.log('response', response)

      if (response) {
        let _schema = formSchema
        _schema.attachFiles = response
        setIsEditErr(false)
        setFormSchema(_schema)
      } else {
        setIsEditErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsEditErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpload = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsUploadErr()
    try {
      console.log('upload')
      let response
      if (isProgress) {
        response = await saveProjectEvaluationProgress(projectId, request)
      } else {
        response = await saveProjectEvaluationEvaluation(projectId, request)
      }
      if (response) {
        let _schema = formSchema
        _schema.attachFiles = response
        setFormSchema(_schema)
        setIsUploadErr(false)
        handleGetSchema()
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (schema) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError()
    try {
      console.log('call delete.')
      const status = await deleteAttachments(projectId, schema.id)
      if (status === 200) {
        console.log('call get.')
        const response = await getAttachments(projectId)
        console.log('getAttachments response', response)
        setFormSchema(response.forms.attachment)
        setIsDeleteError(false)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    var file = await getDownloadProjectEvaluation(projectId, fileObj.path)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await getDownloadProjectEvaluation(projectId, fileObj.path)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onUpload = (data) => {
    console.log('onSubmit data', data)
    const file = data[formSchema.name]
    var formData = new FormData()

    file?.forEach((element) => {
      formData.append('file', element.blobFile)
    })

    handleUpload(formData)
  }

  const onCancel = (data) => {
    console.log(data)
    data[formSchema.name].splice(data[formSchema.name].length - 1, 1)
  }

  const onUpdate = (file, newName) => {
    console.log('onUpdate file', file, 'newName: ', newName)

    file['projectVersionId'] = projectId
    file.label = newName

    console.log('file', file)
    handleUpdate(file)
  }

  const onDelete = (index) => {
    let datas = [...formSchema.attachFiles.value]
    handleDelete(datas[index])
  }

  const onChangSeqNo = async (data, seqNo) => {
    console.log('onChangSeqNo data', data)

    startLoading()
    setIsLoading(true)
    // setIsUploadErr()
    try {
      console.log('onChangSeqNo')
      const response = await changeAttachmentSeqNo(projectId, data.id, seqNo)
      console.log('onChangSeqNo response', response)

      if (response) {
        let _schema = formSchema
        _schema.attachFiles = response
        setFormSchema(_schema)
        // setIsUploadErr(false)
      } else {
        // setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      // setIsUploadErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  console.log(formSchema)

  return (
    <Panel
      shaded
      header={formSchema.header}
      bordered
      collapsible
      defaultExpanded
      style={{ marginBottom: '1em' }}
      ref={(section) => {
        setSection(section)
      }}
    >
      <AttachFilesFormProjectEvaluation
        schema={formSchema}
        register={register}
        Controller={Controller}
        control={control}
        errors={errors}
        setValue={setValue}
        clearErrors={clearErrors}
        onSubmit={handleSubmit(onUpload)}
        onDelete={onDelete}
        onUpdate={onUpdate}
        onDownload={onDownload}
        onPreview={onPreview}
        onCancel={handleSubmit(onCancel)}
        onChangSeqNo={onChangSeqNo}
        isChangSeqNo={true}
        isEditErr={isEditErr}
        isUploadErr={isUploadErr}
        isDeleteError={isDeleteError}
        loading={isLoading}
        setIsProgress={setIsProgress}
      />
    </Panel>
  )
}
